import React from 'react'

const Manual_ordenes_compra_revertir_completa = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Órdenes de Compra - Revertir Orden Completa
        </h2>
        <iframe
          src="https://scribehow.com/embed/Ordenes_de_Compra__Revertir_Orden_Completa__ME6DY93dQU-GQPPYBLv6fQ?as=scrollable"
          className="scribe-iframe-general-178"
          width="100%"
          height="3300"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_ordenes_compra_revertir_completa
